import React from 'react';

import { getSupportedAudioFormatsLabel } from '@trqk/utils';

export const wrongFileTypeAudio = (
    <span className="font-bold">
        Please choose an audio file with one of the following extensions:&nbsp;
        {getSupportedAudioFormatsLabel('or')}
    </span>
);
